<template>
    <router-view />
</template>

<script>
export default {
    name: 'Basic',
};
</script>
